"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var BhtpPurchaseService = (function (_super) {
    __extends(BhtpPurchaseService, _super);
    function BhtpPurchaseService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    BhtpPurchaseService.prototype.getQuote = function (request) {
        var url = this.getFullUrl("/v1/Quote");
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.post(url, request, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    BhtpPurchaseService.prototype.getQuoteByNumber = function (quoteNumber) {
        var url = this.getFullUrl("/v1/Quote/" + quoteNumber);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.get(url, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    BhtpPurchaseService.prototype.saveQuote = function (request) {
        var url = this.getFullUrl('/v1/SaveQuote');
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.post(url, request, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    BhtpPurchaseService.prototype.purchaseQuote = function (request, skipQueue) {
        if (skipQueue === void 0) { skipQueue = false; }
        var url = this.getFullUrl('/v1/Purchase');
        var options = this.getStandardRequestOptions();
        if (skipQueue) {
            var params = new http_1.URLSearchParams();
            params.set('skipQueue', skipQueue.toString());
            options.search = params;
        }
        this.addAuthorizationToken(options);
        return this.http.post(url, request, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    BhtpPurchaseService.prototype.getAgentSmartQuote = function (request) {
        var url = this.getFullUrl("/v1/Agents/SmartQuote");
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        return this.http.post(url, request, options)
            .map(function (res) { return res.json(); })
            .catch(this.handleError);
    };
    return BhtpPurchaseService;
}(base_1.BhtpBaseService));
BhtpPurchaseService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpPurchaseService);
exports.BhtpPurchaseService = BhtpPurchaseService;
//# sourceMappingURL=D:/a/1/s/purchase/src/purchase-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/purchase-service.js